import { useEffect, useState } from "react";
import useApiUrlTranslation from "../components/useApiUrlTranslation";

const useGetFormulaireEventList = ({ params }) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    const [formulaireEventList, setFormulaireEventList] = useState(null);

    const [isLoading, setIsLoading] = useState(true);

    const getFormulaireEventList = async () => {

        await fetch(`${apiUrlTranslation}?action=getFormulaireEventList&params=${params}`)
            .then(res => res.json())
            .then(res => setFormulaireEventList(res))
    }

    useEffect(() => {
        getFormulaireEventList().then(() => {
            setIsLoading(false);
        });

    }, [i18n.resolvedLanguage])

    return { formulaireEventList, isLoading }
}

export default useGetFormulaireEventList;